import { TextField } from '@mui/material';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { DateTime } from 'luxon';
import * as React from 'react';

interface DateTimeFieldProps {
  label: string;
  value: DateTime | undefined;
  setValue: (val: DateTime | undefined) => void;
  disablePast?: boolean;
}

export function DateTimeField({ label, value, setValue, disablePast }: DateTimeFieldProps): JSX.Element {
  return (
    <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale={navigator.language}>
      <DateTimePicker
        disablePast={disablePast}
        label={label}
        value={value ?? null}
        onChange={(newVal) => {
          setValue(newVal ?? undefined);
        }}
        slotProps={{
          textField: (props) => <TextField {...props} variant="outlined" />,
          popper: {
            disablePortal: true,
            popperOptions: { placement: 'auto', strategy: 'fixed' },
          },
        }}
        timezone="system"
      />
    </LocalizationProvider>
  );
}
